<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="法人名/テナントID/テナント名"
        v-model="inputValue"
        @focusin="$emit('focusin')"
      />
      <input
        type="button"
        :value="searchButton"
        class="search_button"
        @click="corporationFindAction"
      />
    </div>
    <controller :router="router"> </controller>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close"> </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from './controller.vue'
import falseModalWindow from '../../../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      showFalseModal: false,
      falseWord: '',
      searchButton: '検索',
      router: '/master/corporations/add',
      showloadingModal: false
    }
  },
  computed: {},
  components: {
    controller,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    corporationFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
    }
  }
}
</script>
<style scoped>
.control_bar {
  background-color: #bbffff;
}
.search {
  width: 45%;
  height: 55px;
  margin: auto 0;
}
.search_button {
  background-color: #5366ce;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/controlbar.vue